import OccupancyAlert from './OccupancyAlert';

export default OccupancyAlert;
